import React, { useEffect, useState } from 'react';
import AuthLayout from '../../layout/authLayout';
import {
  Typography,
  Snackbar,
  Grid,
  FormHelperText,
  FormControl,
  Button,
} from '@mui/material';
import ApiClient from '../../config/api';
import EastIcon from '@mui/icons-material/East';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { convertPersianToEnglish } from '../../components/converter';
import InputOtp from '../../components/otpInput';
import { setRoute } from '../../store/globalSlice';
import getDeviceHash from '../../components/getDeviceHash';
import getDeviceInformation from '../../components/getDeviceInformation';
import getFcmToken from '../../components/getFcmToken';
import getVersion from '../../components/getVersion';
import sendLog from '../../components/sendLog';

const Otp = () => {
  const api = ApiClient();
  const [isLoading, setIsLoading] = useState(false);
  const [token, setToken] = useState('');
  const [error, setError] = useState('');
  const [openRetry, setOpenRetry] = useState(false);
  const [value, setValue] = useState('');
  const [resendCooldown, setResendCooldown] = useState(0);
  const dispatch = useDispatch();
  const phoneNumber = useSelector((st) => st?.auth?.phoneNumber);
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const type = searchParams.get('type');
  const tempToken = searchParams.get('tempToken');
  const [fcmToken, setFcmToken] = useState('');
  const [version, setVersion] = useState('');
  const [deviceInformation, setDeviceInformation] = useState('');
  const [deviceId, setDeviceId] = useState('');

  const sendFcmToken = async () => {
    try {
      const response = await api.post('/api/app/v1/user/devices', {
        application_id: 'shipito',
        application_version: String(version || ""),
        device_id: String(deviceInformation?.osInternalBuildId || ""),
        device_type: String(deviceInformation?.deviceType || ""),
        push_token: String(fcmToken || ""),
        device_os: String(deviceInformation?.osVersion || ""),
        device_os_version: String(deviceInformation?.osVersion || ""),
        device_brand: String(deviceInformation?.productName || ""),
        device_model_id: String(deviceInformation?.modelId || ""),
      });
    } catch (error) {
      console.error(error)
      sendLog(error)
    }
  };

  const onRecievedMessage = (event) => {
    if (event?.data?.type == 'token') {
      setFcmToken(event?.data?.data)
    } else if (event?.data?.type == 'device') {
      setDeviceInformation(event?.data?.data)
    } else if (event?.data?.type == 'version') {
      setVersion(event?.data?.data)
    }
    sendLog(error)
  };

  useEffect(function () {
    window.addEventListener('message', onRecievedMessage);

    return function () {
      window.removeEventListener('message', onRecievedMessage);
    };
  });

  useEffect(() => {
    getFcmToken();
    getVersion();
    getDeviceInformation();
  }, []);

  const getCode = async (hash) => {
    try {
      setIsLoading(true);
      const convertedPhoneNumber = convertPersianToEnglish(phoneNumber);
      const response = await api.post('/api/app/v1/auth/otp', {
        mobile_no: convertedPhoneNumber,
        otp_type: type,
      });
      setToken(response.data.temp_token);
      setIsLoading(false);
      setResendCooldown(120);
    } catch (error) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    // const handleMessage = (event) => {
    //   alert(event.data);
    if (type == 'otp_login') {
      getCode('');
    } else {
      setResendCooldown(120);
    }
    // };

    // window.addEventListener("message", handleMessage);

    // return () => {
    //   window.removeEventListener("message", handleMessage);
    // };
  }, []);

  // useEffect(() => {
  //   const ac = new AbortController();
  //   if ("OTPCredential" in window) {
  //     navigator.credentials
  //       .get({
  //         otp: { transport: ["sms"] },
  //         signal: ac.signal,
  //       })
  //       .then((otp) => {
  //         setValue(otp?.code);
  //       })
  //       .catch((err) => {
  //         console.log(err);
  //       });

  //     return () => ac.abort();
  //   }
  // }, []);

  const onSubmit = async (code) => {
    if (code.length === 6) {
      try {
        setIsLoading(true);
        setError('');
        const convertedCode = convertPersianToEnglish(code);
        const response = await api.post('/api/app/v1/auth/verify-otp', {
          code: convertedCode,
          temp_token: token,
          new_password: '',
          new_password_confirm: '',
          channel: 'shipito',
          app_name: 'shipito',
        });

        sendFcmToken()
        localStorage.setItem('info', JSON.stringify(response.data));
        dispatch(setRoute('missions'));
        navigate('/missions', { replace: true });
        window.location.reload();
      } catch (error) {
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          setError(error.response.data.message);
        }
      }
      setIsLoading(false);
    } else {
      setError('لطفا رمز پیامک شده را وارد نمایید');
      setIsLoading(false);
    }
  };

  useEffect(() => {
    setOpenRetry(false);
    if (tempToken) {
      setToken(tempToken);
    }
    getDeviceHash();
    if (!phoneNumber) {
      dispatch(setRoute('/'));
      navigate('/');
    }
  }, []);

  useEffect(() => {
    let timer;
    if (resendCooldown > 0) {
      timer = setInterval(() => {
        setResendCooldown((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(timer);
  }, [resendCooldown]);

  const handleChange = (otpCode) => {
    if (otpCode?.length === 6) {
      onSubmit(otpCode);
    }
    setValue(otpCode);
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenRetry(false);
  };

  return (
    <AuthLayout>
      <Snackbar
        open={openRetry}
        autoHideDuration={2000}
        onClose={handleClose}
        message="رمز یکبار مصرف برای شما ارسال شد"
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      />
      <EastIcon
        className={'clickable'}
        sx={{ marginTop: '20px', paddingRight: '20px', paddingLeft: '20px' }}
        onClick={() => {
          navigate(-1);
        }}
      />
      <Typography
        paddingRight={'20px'}
        paddingLeft={'20px'}
        fontSize={24}
        fontWeight={600}
        marginTop={'24px'}
      >
        کد تایید را وارد نمایید
      </Typography>
      <Typography
        paddingRight={'20px'}
        paddingLeft={'20px'}
        color={'primary.gray'}
        fontSize={16}
        fontWeight={600}
        marginTop={'12px'}
        marginBottom={'32px'}
      >
        کد تایید را به شماره {phoneNumber} فرستادیم.
      </Typography>
      <Grid
        paddingRight={'20px'}
        paddingLeft={'20px'}
        container
        flexDirection={'column'}
      >
        <Grid
          display={'flex'}
          item
          style={{ direction: 'ltr' }}
          justifyContent={'center'}
        >
          <InputOtp
            inputWrapperClass={'styles_otpInputWrapper'}
            disabled={isLoading}
            otpLength={6}
            onChange={handleChange}
            value={value}
            autocomplete="one-time-code"
          />
        </Grid>
        <Grid item>
          <FormControl
            size="small"
            variant="standard"
            fullWidth
            error={Boolean(error)}
          >
            {error && <FormHelperText>{error}</FormHelperText>}
          </FormControl>
          <Button
            onClick={() => {
              onSubmit(value);
            }}
            disabled={isLoading}
            sx={{
              marginTop: '24px',
              width: '100%',
              height: '57px',
              borderRadius: '8px',
              color: 'primary.contrastText',
              fontFamily: 'iran-sans-light',
              fontSize: '16px',
              fontWeight: '600',
            }}
            size="large"
            variant="contained"
          >
            تایید و ادامه
          </Button>
        </Grid>
        <Grid
          item
          marginTop={'16px'}
          justifyContent={'flex-start'}
          display={'flex'}
        >
          {resendCooldown === 0 ? (
            <Typography
              onClick={() => {
                if (resendCooldown === 0) {
                  getCode();
                  setOpenRetry(true);
                }
              }}
              sx={{
                marginLeft: '5px',
                fontWeight: 600,
                textDecoration: isLoading ? 'none' : 'underline',
              }}
              color={isLoading ? '#A1A1AA' : '#000000'}
              className={isLoading ? '' : 'clickable'}
            >
              ارسال کد
            </Typography>
          ) : (
            <Typography
              color={'#A1A1AA'}
            >{`ارسال دوباره کد (${resendCooldown} ثانیه)`}</Typography>
          )}
        </Grid>
      </Grid>
    </AuthLayout>
  );
};

export default Otp;
